import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { SearchResponse } from '../models/SearchResponse';
import { Observable } from 'rxjs';
import { PagedData } from '../models/PagedData';
import { PagedList } from '../models/PagedList';
import { ZipCodeSearchDto } from '../models/ZipCodeSearchDto';

@Injectable({
  providedIn: 'root'
})
export class SearchEngineService extends BaseService {

  apiBaseUrl = environment.LRNEXT_API_URL;

  constructor(
    protected http: HttpClient,
    protected authService:AuthService) 
  {
    super(authService, http);
  }

  search(searchTerm: string, page = 1, pageSize = 30) : Observable<PagedData<SearchResponse>> {
    const trimmed = (searchTerm ?? '').trim();
    const url = `${this.apiBaseUrl}/search?query=${encodeURIComponent(trimmed)}&page=${page}&pageSize=${pageSize}`;
    return this.get<PagedData<SearchResponse>>(url);
  }

  searchZipCodes(
    query?: string,
    latitude?: number,
    longitude?: number,
    distanceInMiles?: number,
    page: number = 1,
    pageSize: number = 10
  ): Observable<PagedList<ZipCodeSearchDto>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (query) {
      params = params.set('query', query);
    }
    if (latitude !== undefined && latitude !== null) {
      params = params.set('latitude', latitude.toString());
    }
    if (longitude !== undefined && longitude !== null) {
      params = params.set('longitude', longitude.toString());
    }
    if (distanceInMiles !== undefined && distanceInMiles !== null) {
      params = params.set('distanceInMiles', distanceInMiles.toString());
    }

    const url = `${this.apiBaseUrl}/search/zipcodes`;
    return this.get<PagedList<ZipCodeSearchDto>>(url, { params });
  }

}
